
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/member-registration",
      function () {
        return require("private-next-pages/member-registration.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/member-registration"])
      });
    }
  